import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { pageSlug, trackPv, trackCta } from '../lib/track';

// Pages jamais mesurées : back-office et flux d'authentification.
const EXCLUDED = /^(admin|auth|login|register|profile)/;

/**
 * Mesure d'audience first-party (sans cookie) :
 *  - une vue 'pv' à chaque changement de route publique ;
 *  - un clic 'cta' pour tout élément portant data-cta (délégation globale,
 *    aucun besoin de câbler chaque bouton individuellement).
 */
export default function AudienceTracker() {
  const location = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    const slug = pageSlug(location.pathname);
    if (!slug || EXCLUDED.test(slug) || slug === lastTracked.current) return;
    lastTracked.current = slug;
    trackPv(slug);
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (event) => {
      const target = event.target.closest('[data-cta]');
      const id = target?.getAttribute('data-cta');
      if (id) trackCta(id);
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
}
